import type { CapacityRequestView } from "@/client/features/capacity-request/capacity-request-api";
import { apiFetch } from "@/client/lib/api";

/** One row in the staff inquiry list (no answers; that's the detail view). */
export interface AdminCapacityRequest {
  id: string;
  email: string;
  company: string | null;
  contactName: string | null;
  role: string | null;
  status: "draft" | "submitted";
  submittedAt: string | null;
  updatedAt: string;
}

/** Whether the list includes in-progress drafts or only submitted inquiries. */
export type InquiryScope = "submitted" | "all";

/** Staff-only capacity-request (pre-tenant inquiry) directory. */
export const capacityRequestsAdminApi = {
  list: (scope: InquiryScope = "submitted") =>
    apiFetch<{ requests: AdminCapacityRequest[]; truncated: boolean }>(
      `/staff/capacity-requests?status=${scope === "all" ? "all" : "submitted"}`,
    ),
  get: (id: string) =>
    apiFetch<{ request: CapacityRequestView }>(
      `/staff/capacity-requests/${encodeURIComponent(id)}`,
    ),
  /** Permanently delete an inquiry (staff-admin only). Clears its magic-link tokens. */
  remove: (id: string) =>
    apiFetch<void>(`/staff/capacity-requests/${encodeURIComponent(id)}`, { method: "DELETE" }),
};
